import { render, staticRenderFns } from "./artifact-list.vue?vue&type=template&id=5679d1ae"
import script from "./artifact-list.vue?vue&type=script&lang=js"
export * from "./artifact-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports